import {LiveEventArtist} from '@app/admin/live-events/interfaces/live-event-artist';
import {LiveEventTicket} from '@app/admin/live-events/interfaces/live-event-ticket';
import {LiveEventPartner} from '@app/admin/live-events/interfaces/live-event-partner';
import {LiveEventTicketingType} from '@app/admin/live-events/interfaces/crupdate-live-event-payload';

export const LIVE_EVENT_MODEL = 'live_event';

export interface LiveEvent {
  id: number;
  name: string;
  artists?: LiveEventArtist[]; // relation many-to-many
  tickets?: LiveEventTicket[]; // via /tickets-office
  partners?: LiveEventPartner[];
  slug: string;
  capacity?: number;
  attendance?: number;
  daily_attendance?: Record<string, number>;
  sold_quantity?: number;
  starts_at: string; // ISO 8601
  ends_at: string;   // ISO 8601
  location_name?: string | null;
  address?: string | null;
  postal_code?: string | null;
  city?: string | null;
  region?: string | null;
  country: string;
  latitude?: number | null;
  longitude?: number | null;
  timezone?: string | null;
  map_link?: string | null;
  source_url?: string | null;
  ticket_url?: string | null;
  ticketing_type?: LiveEventTicketingType;
  image?: string;
  poster?: string;
  image_format?: 'square' | 'landscape' | 'poster' | 'portrait';
  artwork?: string;
  artwork_large?: string;
  thumb_16_9?: string;
  thumb_1080?: string;
  thumb_4_5?: string;
  thumb_9_16?: string;
  description?: string | null;
  available: boolean;
  published: boolean;
  is_ticketed: boolean;
  can_update?: boolean;
  can_sell?: boolean;
  can_scan?: boolean;
  created_by: number;
  created_at?: string | null; // ISO 8601
  updated_at?: string | null; // ISO 8601
  model_type: 'live_event';
}
